// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ActiveStatus } from './active-status';
import { Addon } from './addon';
import { FeatureChoice } from './feature-choice';
import { FeatureKind } from './feature-kind';
import { ProductTypeFeatureMap } from './product-type-feature-map';
import { ActiveStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags
import { StringFns } from '@/shared/string-fns';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Feature extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  getDisplayName() {
    if (StringFns.isNullEmptyOrWhiteSpace(<string>this.docName)) {
      return this.name
    } else {
      return this.docName
    }
  }

  get displayName() {
    return this.getDisplayName() as any;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** String(50) */
  docName?: string;
  /** Int32 FK featureKind */
  featureKindId!: number;
  /** Boolean */
  mismatchAddonIsCrossAccount!: boolean;
  /** String(60) */
  mismatchAddonNameAndLocation?: string;
  /** String(50) */
  name!: string;
  /** String(50) */
  _origName?: string;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** Inv FK mismatchFeatureId */
  addons!: Addon[];
  /** Inv FK featureId */
  featureChoices!: FeatureChoice[];
  /** FK featureKindId */
  featureKind!: FeatureKind;
  /** Inv FK featureId */
  productTypeFeatureMaps!: ProductTypeFeatureMap[];
}

